import { Component, OnInit, ViewChildren, QueryList, ViewChild } from "@angular/core";
import { Booking } from "../../shared/models/booking.model";
import {
    ActionUpdaterService,
    ApiError
} from "../../shared/services/action-updater.service";
import { BookingService } from "../../shared/services/booking.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import * as $ from "jquery";
import { GxConstants } from "app/shared/constants/gx.constants";
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import { InitialDataService } from "../../initial-data.service";
import { LocalStorageService } from "app/shared/services/local-storage.service";
import { ProductUrl } from "app/shared/models/availability.model";
import { ProductTypeUrl } from "app/shared/models/enums/ProductTypeUrl.enum";
import { TravelProductService } from "app/shared/services/travel-product.service";
import { MyGreyhoundService } from "../../my-greyhound/my-greyhound.service";
import { SeatAllocationsComponent } from "../../shared/components/seat-allocations/seat-allocations.component";
import { ConfirmDialogComponent } from "app/shared/dialogs/confirm-dialog/confirm-dialog.component";

@Component({
    selector: "gaweb-seat-confirmation",
    templateUrl: "seat-confirmation.component.html"
})
export class SeatConfirmationComponent implements OnInit {
    @ViewChildren(SeatAllocationsComponent) seatAllocationComponents: QueryList<
        SeatAllocationsComponent
    >; 
    @ViewChild('seatWarning') public seatWarning: ModalDirective;

    loading: boolean;
    booking: Booking;
    bookings: Array<Booking>;
    travelGuid: string;
    bookingConfirmed: boolean;
    errored: boolean;
    errorMessage: boolean;
    navigatingToBooking: boolean[];
    navigatingToAccount: boolean;
    loadingData: boolean;
    bookingGuid: string;
    isLoggedIn: boolean;
    parentBookingGuid: any;
    productReference: any;
    productUrl: any;
    productType: any;
    productTypeName: any;
    nextUrl: string;
    productName: any;
    totalFreeLoyaltyTrips = 0;
    editModeActive = false;

    constructor(
        public travelPackageService: TravelProductService,
        private readonly initialDataService: InitialDataService,
        private router: Router,
        private readonly bookingsService: BookingService,
        private readonly localStorageService: LocalStorageService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly actionUpdaterService: ActionUpdaterService,
        private readonly myGreyhoundService: MyGreyhoundService
    ) {}

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.parentBookingGuid = params["bookingGuid"];
            this.productReference = params["product-reference"];
            this.productUrl = new ProductUrl(
                this.router.url,
                this.initialDataService
            );
            const productTypeStr = params["product-type"];
            this.productType = this.productUrl.ProductTypeUrl;
            this.productTypeName = this.productUrl.ProductName;
        });

        try {
            this.travelGuid = this.localStorageService.getOfflineBooking().travels[0].TravelGUID;
        } catch (ex) {
            this.travelGuid = null;
        }
        this.nextUrl = this.initialDataService.expressPayment;
        if (
            this.productType === ProductTypeUrl.travelPasses ||
            this.productType === ProductTypeUrl.expressBooking
        ) {
            this.bookings = this.travelPackageService.bookings = [
                this.localStorageService.getOnlineBooking()
            ];
            if (
                !this.bookings[0] &&
                this.productType === ProductTypeUrl.travelPasses
            ) {
                window.location.href = this.initialDataService.travelPassesParentFolderUrl;
                return;
            } else if (
                !this.bookings[0] &&
                this.productType === ProductTypeUrl.expressBooking
            ) {
                window.location.href = this.initialDataService.makeABookingUrl;
                return;
            }
            this.nextUrl = this.initialDataService.expressPayment;
        } else if (this.productType === ProductTypeUrl.manageBooking) {
            this.bookings = this.travelPackageService.bookings = [
                this.localStorageService.getOnlineBooking()
            ];
            this.parentBookingGuid = this.bookings[0].BookingGuid;
            this.nextUrl = this.initialDataService.expressPayment;
        } else {
            if (!this.travelPackageService.currentProduct) {
                this.loadingData = true;
                this.productReference = this.activatedRoute.snapshot.params[
                    "product-reference"
                ];
                let getProductfunc;
                switch (this.productType) {
                    case ProductTypeUrl.accommodation:
                        break;
                    case ProductTypeUrl.experience:
                        getProductfunc = this.travelPackageService
                            .getTourExperience;
                        break;
                    case ProductTypeUrl.package:
                        getProductfunc = this.travelPackageService.getPackage;
                        break;
                    default:
                }
                getProductfunc
                    .call(this.travelPackageService, this.productReference)
                    .subscribe(travelProduct => {
                        this.loadingData = false;
                        this.productName = travelProduct.title;
                        this.travelPackageService.currentProduct = travelProduct;
                    });
            } else {
                this.productName = this.travelPackageService.currentProduct.title;
            }

            var productRef = window.location.pathname.split("/")[1];
            const categoryReference = this.activatedRoute.snapshot.params[
                "category-reference"
            ];
            const productReference = this.activatedRoute.snapshot.params[
                "product-reference"
            ];

            this.nextUrl = `/${productRef}/${categoryReference}/${productReference}/book-now/${this.parentBookingGuid}/pay-now`;
        }

        if (!this.travelPackageService.bookings) {
            this.loadingData = true;
            this.bookingsService
                .getBookings(this.parentBookingGuid)
                .subscribe((bookings: Array<Booking>) => {
                    this.loadingData = false;
                }, this.actionUpdaterService.onError);
        } else {
            this.bookings = this.travelPackageService.bookings;
        }

        // Checking for free loyalty trips
        this.bookings.forEach(booking => {
            if (booking.CustomerGuid != null) {
                this.myGreyhoundService
                    .getTripHistory(booking.CustomerGuid)
                    .subscribe(data => {
                        data.forEach(tripCollection => {
                            if (
                                tripCollection.Description === "Active Bookings"
                            ) {
                                tripCollection.CustomerTrips.forEach(trip => {
                                    if (
                                        trip.BookingNumber ===
                                        booking.BookingNumber
                                    ) {
                                        this.totalFreeLoyaltyTrips++;
                                        if (
                                            this.totalFreeLoyaltyTrips ===
                                            this.bookings.length
                                        ) {
                                            this.nextUrl = `${this.initialDataService.confirmationUrl}?booking=${this.bookings[0].BookingGuid}`;
                                        }
                                    }
                                });
                            }
                        });
                    });
            }
        });

        setTimeout(() => {
            this.seatAllocationComponents.forEach(seatAllocationComponent => {
                seatAllocationComponent.editModeActive.subscribe(val => {
                    this.editModeActive = val;
                });                                                
            });
        }, 500);
    }

    back() {
        if (
            this.productType === ProductTypeUrl.travelPasses ||
            this.productType === ProductTypeUrl.expressBooking
        ) {
            window.history.back();
        } else {
            const productRef = window.location.pathname.split("/")[1];
            const categoryReference = this.activatedRoute.snapshot.params[
                'category-reference'
            ];
            const productReference = this.activatedRoute.snapshot.params[
                'product-reference'
            ];

            this.router.navigate([`/${productRef}/${categoryReference}/${productReference}/book-now/`]);
        }
    }
    public continueToPayment() {

        let completedSeatAllocations = 0;
        this.seatAllocationComponents.forEach(seatAllocationComponent => {
           if(seatAllocationComponent.allSeatsSelected === true) {
            completedSeatAllocations++;
           }
        });
        let total = this.seatAllocationComponents.first.passengerTotal;
        let current = this.seatAllocationComponents.first.currentSeats.length;
        let seatChanges = this.seatAllocationComponents.first.seatChanges.length;

        if (total === current && seatChanges === 0 && completedSeatAllocations >= this.seatAllocationComponents.length && this.seatAllocationComponents.some(seatAllocationComponent => seatAllocationComponent.isUpdating()) == false) {
            window.location.href = this.nextUrl;
        } else {
            this.seatWarning.show();
        }
    }

    cancelModal() {
        this.seatWarning.hide();
    }

    okModal() {
        window.location.href = this.nextUrl;
    }
}



// WEBPACK FOOTER //
// ./src/app/travel-products/seat-confirmation/seat-confirmation.component.ts